import type { RobotProfileId } from "lib/robotProfileApi";

/** Robot profiles that expose the unified /docking action (Genisom GB/GBW, Lynx M20). */
export const DOCKING_ENABLED_PROFILES: ReadonlySet<RobotProfileId> = new Set([
    "gb",
    "gbw",
    "lynx", // Lynx M20 — profile id on ARC is "lynx"
]);

export function isDockingEnabledForProfile(
    profile: RobotProfileId | null | undefined
): boolean {
    return profile != null && DOCKING_ENABLED_PROFILES.has(profile);
}

